// vendors
import { combineReducers } from "@reduxjs/toolkit";

// slices
import mainReducer from "./main.slice";

export const flowBuilderReducer = combineReducers({
  main: mainReducer,
});
